import React from 'react';
import { Box, Breadcrumbs, CircularProgress, Container, Link, Typography } from '@material-ui/core';
import { CouponPackMasterForm } from './Form';
import { MenuHeaderTemplate } from '../../../components/templates/MenuHeaderTemplate';
import { useHistory, useLocation } from 'react-router-dom';
import {
  CouponPackMasterFormInput,
  CouponPackMasterFormProps,
  CouponPackMasterImageBodyProps,
} from '../../../types/couponPackMaster';
import { useCreateCouponPackMaster } from './hooks/create-coupon-pack';

export type CreateCouponPackMasterPageProps = {
  previousValues?: CouponPackMasterFormInput;
  submitStepMessage?: string;
  onSubmit: (input: CouponPackMasterFormInput) => void;
  logoImageProps: CouponPackMasterImageBodyProps;
  couponImageProps: CouponPackMasterImageBodyProps;
  loading: boolean;
};

export const CreateCouponPackMaster: React.FC<CreateCouponPackMasterPageProps> = (props) => {
  if (!props.previousValues) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  const formProps: CouponPackMasterFormProps = {
    loading: props.loading,
    onSubmit: props.onSubmit,
    previousValues: props.previousValues,
    submitStepMessage: props.submitStepMessage,
    logoImageProps: props.logoImageProps,
    couponImageProps: props.couponImageProps,
    submitLabel: '作成する',
    isUpdate: false,
  };

  return <CouponPackMasterForm {...formProps} />;
};

export const CreateCouponPackMasterPage: React.FC = () => {
  const history = useHistory();
  const { state } = useLocation<string>();
  const createCouponPackMaster = useCreateCouponPackMaster(state);

  return (
    <MenuHeaderTemplate header={{ title: '回数券マスタ新規作成' }}>
      <Container maxWidth="xl">
        <Breadcrumbs>
          <Link
            href="#"
            onClick={() =>
              history.push({
                pathname: '/coupon-pack-masters',
                search: history.location.search,
              })
            }
          >
            回数券マスタ一覧
          </Link>
          <Typography>回数券マスタ新規作成</Typography>
        </Breadcrumbs>
        <Box>
          <CreateCouponPackMaster {...createCouponPackMaster} />
        </Box>
      </Container>
    </MenuHeaderTemplate>
  );
};
